var exports = {
  "I$": "xcc377c0b--163a75--compilation",
  "Kk": "xcc377c0b--163a75--icon",
  "UE": "xcc377c0b--163a75--arrow",
  "Qs": "xcc377c0b--163a75--content",
  "DD": "xcc377c0b--163a75--title",
  "Nu": "xcc377c0b--163a75--no-wrap",
};

module.exports = exports;
